import React from "react";
import WordPressSVG from "../../../../assets/svg/wordpress.svg";
import Modal from "../../../../components/common/Modal";

const WordPressGuideModal = ({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) => {
  return (
    <Modal
      width={750}
      onRequestClose={onRequestClose}
      isOpen={true}
    >
      <section className="max-w-3xl px-4 pt-4 pb-6 md:px-8 md:pt-8 md:pb-10">
        <header className="flex items-center gap-3 mb-4">
          <img
            alt="WordPress logo"
            src={WordPressSVG}
            width={40}
            height={40}
          />
          <h2 className="text-xl font-semibold">
            Setup a WordPress Application Password
          </h2>
        </header>

        <ol className="list-decimal list-inside space-y-3 text-gray-900 ml-1">
          <li>Go to your WordPress dashboard.</li>
          <li>
            Navigate to your user profile.
            <ul className="list-none ml-5 mt-1 space-y-1">
              <li>
                <strong>a.</strong> Scroll down to{" "}
                <strong>Application Passwords</strong>, name it (e.g.,
                “ArticleX”), and generate it.
              </li>
              <li>
                <strong>b.</strong> Copy the password and paste it into the
                ArticleX<strong> App Password</strong> field.
              </li>
            </ul>
          </li>
          <li>Make sure the connection fields are filled out</li>
          <li>
            Click <strong>Test</strong> to test the connection from ArticleX.
          </li>
          <li>
            Once successful, click <strong>Save</strong>.
          </li>
        </ol>
      </section>
    </Modal>
  );
};

export default WordPressGuideModal;
